export default {
	defaultPageParams: {
		recommendedLength: 300,
		maximumRecommendedLength: 400,
	},
	productPageParams: {
		recommendedLength: 140,
		maximumRecommendedLength: 200,
	},
};
